import footerMusic from './components/item/FooterMusic.vue';
export default {
  components: {
    footerMusic
  }
};